import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, onSnapshot, where } from "firebase/firestore";

export const useFetchAppointments = (docCollection, date = false, tid = false) => {

    const [documents, setDocuments] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        const collectionRef = collection(db, docCollection);
        let q;

        if (date) {
            q = query(
                collectionRef,
                where("date", "==", date)
            )
        } else if (tid) {
            q = query(
                collectionRef,
                where("tid", "==", tid)
            )
        } else {
            setDocuments([]);
            setLoading(false);
            return;
        }

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const loadedDocuments = querySnapshot.docs
                .map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
                .sort((a, b) => (a.hours_index || 0) - (b.hours_index || 0));

            setDocuments(loadedDocuments);
            setLoading(false);
        }, (error) => {
            setError(error);
            setDocuments([]);
            setLoading(false);
        });

        return unsubscribe;

    }, [date, docCollection, tid])

    return { documents, loading, error };
};
